import { AHButton, AHSeparator, Box } from "arkh";

import React, { useCallback, useState } from "react";
import isEqual from "react-fast-compare";
import { KPIEditScreenProps, KPIFillMode } from "./KPIEditParamList";
import { KPIFrequencySelectorComponent } from "../Create/KPIFrequencySelectorComponent";
import { produceScheduleRule } from "../components/produceScheduleRule";
import { graphql, useMutation } from "react-relay";
import { useModalInsets } from "../../../components/mobile/useModalInsets";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export function KPIEditFrequencyScreen(
  props: KPIEditScreenProps<"KPIEditFrequency">
) {
  const insets = useModalInsets();
  const [selectedDays, setSelectedDays] = useState<number[]>(
    props.route.params.selectedDays
  );
  const [fillMode, setFillMode] = useState<KPIFillMode>(
    props.route.params.fillMode
  );

  const [updateSchema, loading] = useMutation(graphql`
    mutation KPIEditFrequencyMutation(
      $routineId: ID!
      $rule: RecurrenceRuleInput!
    ) {
      routine(id: $routineId) {
        updateSchedule(input: { rules: [$rule] }) {
          routine {
            id
            schedule {
              rules {
                freq
                byhour
                byminute
                byweekday
              }
            }
          }
        }
      }
    }
  `);

  const onUpdateSchema = useCallback(() => {
    updateSchema({
      variables: {
        routineId: props.route.params.routineId,
        rule: produceScheduleRule(
          selectedDays,
          fillMode,
          props.route.params.taskId
        ),
      },
      onCompleted: props.navigation.goBack,
      onError: (e) => {
        console.log("KPIAdminEditFrequency onUpdateSchema", e);
      },
    });
  }, [
    fillMode,
    props.navigation,
    props.route.params.routineId,
    props.route.params.taskId,
    selectedDays,
    updateSchema,
  ]);

  const intl_tokens = useIntlTokens();

  return (
    <>
      <KPIFrequencySelectorComponent
        selectedDays={selectedDays}
        onSetSelectedDays={setSelectedDays}
        fillMode={fillMode}
        onSetFillMode={setFillMode}
      />
      <AHSeparator />
      <Box space="medium" insets={{ bottom: insets.bottom }}>
        <AHButton
          themeType="primary"
          disabled={
            fillMode === props.route.params.fillMode &&
            isEqual(props.route.params.selectedDays, selectedDays)
          }
          loading={loading}
          onPress={onUpdateSchema}
          title={intl_tokens.Save}
        />
      </Box>
    </>
  );
}
